// @flow
import get from 'lodash/get';
import { SOURCES_MODULE_NAME, LOADER_STATE_NAME } from '../constants';

export function isSourceLoaderShow(state: Object): boolean {
  return get(state[SOURCES_MODULE_NAME], [LOADER_STATE_NAME, 'isShow']) || false;
}



// WEBPACK FOOTER //
// ./app/Sources/loader/selectors.js